"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dropdown_select_1 = __importDefault(require("react-dropdown-select"));
var PostCategories = /** @class */ (function (_super) {
    __extends(PostCategories, _super);
    function PostCategories(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function () {
            var optionHTML = _this.props.options.map(function (category, i) {
                return react_1.default.createElement("div", null,
                    react_1.default.createElement("input", { name: _this.props.postType, onChange: function () { _this.categoryChanged(category.value); }, type: "radio", id: _this.props.postType + category.value, key: i, value: category.value, checked: _this.props.value && category.value === _this.props.value }),
                    react_1.default.createElement("label", { htmlFor: _this.props.postType + category.value }, category.label.replace(/&amp;/g, '&')));
            });
            return optionHTML;
        };
        _this.categoryChanged = function (value) {
            _this.setState({
                value: value
            });
            _this.props.handler(value, _this.props.postType);
        };
        _this.state = {
            value: _this.props.value,
        };
        return _this;
    }
    PostCategories.prototype.setValues = function (values) {
        console.log("Value: ", values[0].value === "" ? -1 : values[0].value);
        this.categoryChanged(values[0].value === "" ? -1 : values[0].value);
        window.scrollTo(0, window.scrollY);
    };
    PostCategories.prototype.render = function () {
        var _this = this;
        var classes = (this.props.type === "buttons") ? 'posts_button' : 'posts__select choices';
        // return (
        //     <select className={classes} name={this.props.postType} id={this.props.postType}
        //             onChange={this.categoryChanged}>
        //         <option selected={true} disabled={true}>Category</option>
        //         <option value={""}>All</option>
        //         {this.renderOptions()}
        //     </select>
        // );
        // let valueSet: boolean = this.state === undefined && this.state.value === undefined;
        // console.log("Value set: " + valueSet);
        if (this.props.options) {
            var options = __spreadArray([{ label: "All", value: "" }], this.props.options, true);
            // this.props.options.forEach(option => {
            //     option.label = option.label.replace(/&amp;/g, '&');
            //     options.push({
            //         name: option.label,
            //         value: option.value,
            //     })
            // })
            console.log("Options Props: ", this.props.options);
            console.log("Options: ", options);
            if (options.length !== 0) {
                if (this.props.type === 'dropdown') {
                    if (this.state.value !== null) {
                        return (react_1.default.createElement("div", { className: "post__dropdown post__" + this.props.postType },
                            react_1.default.createElement(react_dropdown_select_1.default, { values: [options.find(function (opt) { return opt.value === _this.state.value; })], required: true, name: "select", options: options, searchable: false, closeOnSelect: true, closeOnScroll: false, onChange: function (values) { return _this.setValues(values); }, onDropdownOpen: function () {
                                    var guideContainer = document.querySelector('.guide-container');
                                    if (guideContainer) {
                                        guideContainer.scrollTo(0, 0);
                                    }
                                    window.scrollTo(0, window.scrollY);
                                    console.log("Window scrolling");
                                }, onDropdownClose: function () {
                                    var guideContainer = document.querySelector('.guide-container');
                                    if (guideContainer) {
                                        guideContainer.scrollTo(0, 0);
                                    }
                                    window.scrollTo(0, window.scrollY);
                                } })));
                    }
                    else {
                        return (react_1.default.createElement("div", { className: "post__dropdown post__" + this.props.postType },
                            react_1.default.createElement(react_dropdown_select_1.default, { values: [], required: true, name: "select", options: options, searchable: false, closeOnSelect: true, closeOnScroll: false, onChange: function (values) { return _this.setValues(values); }, onDropdownOpen: function () {
                                    var guideContainer = document.querySelector('.guide-container');
                                    if (guideContainer) {
                                        guideContainer.scrollTo(0, 0);
                                    }
                                    window.scrollTo(0, window.scrollY);
                                    console.log("Window scrolling");
                                }, onDropdownClose: function () {
                                    var guideContainer = document.querySelector('.guide-container');
                                    if (guideContainer) {
                                        guideContainer.scrollTo(0, 0);
                                    }
                                    window.scrollTo(0, window.scrollY);
                                } })));
                    }
                }
                else if (this.props.type === 'buttons') {
                    return (react_1.default.createElement("fieldset", { className: "post__buttons post__" + this.props.postType },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("input", { name: this.props.postType, onChange: function () {
                                    _this.categoryChanged(-1);
                                }, type: "radio", id: this.props.postType + "-all", value: "", checked: this.state.value === null && this.props.value === null }),
                            react_1.default.createElement("label", { htmlFor: this.props.postType + "-all" }, "All")),
                        this.renderOptions()));
                }
            }
        }
    };
    PostCategories.defaultProps = {
        value: null,
    };
    return PostCategories;
}(react_1.default.Component));
exports.default = PostCategories;
